import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Dropdown, Icon, Loader, Table } from 'semantic-ui-react';
import { adminReportOptions, deptOptions, ReportData, reportOptions } from './TimeSheet';
import agent from '../../../../app/api/agent';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { useStore } from '../../../../app/stores/store';


const NFAIDAilyReport = ({ titleLoader, projectList }: { titleLoader: boolean; projectList: { id: string; name: string; value: string }[] }) => {
  const {userStore} = useStore();
  const { user, userList, loadUsers } = userStore;
  const [titleWise, setTitleWise] = useState<ReportData[]>([]);
  const [dateWise, setDateWise] = useState<ReportData[]>([]);
  const [teamWise, setTeamWise] = useState<ReportData[]>([]);
  const [employeeWise, setEmployeeWise] = useState<ReportData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedReport, setSelectedReport] = useState<string>('');
  const [empOptions, setEmpOptions] = useState<{ key: string; text: string; value: string }[]>([]);
  const [selectedTitle, setSelectedTitle] = useState<string>('');
  const [selectedDept, setSelectedDept] = useState<string>('');
  const [selectedEmp, setSelectedEmp] = useState<string>('');
  const [selectedDeptForDateWise, setSelectedDeptForDateWise] = useState<string>('');
  const currentDate = new Date();
  const [startDate, setStartDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
  const [endDate, setEndDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
  const department = user?.departmentName as string;
  const empId = user?.displayName as string;

  useEffect(() => {
    if (userList.length === 0) loadUsers();
  }, [userList.length, loadUsers]);

  useEffect(() => {
    const tempOptions = userStore.getUsers.map((x) => ({
        key: x.id,
        text: x.displayName,
        value: x.id,
    }));
    setEmpOptions(tempOptions);
  }, [userStore.getUsers]);

  const setDate = (data: Date, type: 'start' | 'end') => {
    const formattedDate = moment(data).format('MM-DD-YYYY');
      if (type === 'start') {
          setStartDate(formattedDate);
      } else {
          setEndDate(formattedDate);
      }
  }; 

  const calculateTotals = (data: ReportData[]): { totalCompReel: number; totalHours: string } => {
    let totalCompReel = 0;
    let totalMinutes = 0;
  
    data.forEach(report => {
      if (report.comp_Reel) {
        totalCompReel += parseFloat(String(report.comp_Reel));
      }
      if (report.total_Hours) {
        // Ensure total_Hours is a string before splitting
        const timeParts = String(report.total_Hours).split(':').map(Number);
        if (timeParts.length === 2) {
          const [hours, minutes] = timeParts;
          totalMinutes += hours * 60 + minutes;
        }
      }
    });
  
    // Convert total minutes back to hours and minutes
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    const formattedTotalHours = `${totalHours}:${String(remainingMinutes).padStart(2, '0')}`;
  
    return { totalCompReel, totalHours: formattedTotalHours };
  };

  const handleChangeTitle = async (e: React.SyntheticEvent<HTMLElement>, data: any)=>{
    const newTitle = data.value as string;
    setSelectedTitle(newTitle);
    setTitleWise([]);
  }

  const handleChangeDept= async (e: React.SyntheticEvent<HTMLElement>, data: any)=>{
    const newDept = data.value as string;
    setSelectedDept(newDept);
    setTeamWise([]);
  }

  const handleChangeDeptForDateWise = (e: React.SyntheticEvent<HTMLElement>, data: any) => {
    const newDept = data.value as string;
    setSelectedDeptForDateWise(newDept);
    setDateWise([]);
  }

  const handleChangeEmp= async (e: React.SyntheticEvent<HTMLElement>, data: any)=>{
    const newEmp = data.value as string;
    setSelectedEmp(newEmp);
    setEmployeeWise([]);
  }

  const handleChangeReport = (e: React.SyntheticEvent<HTMLElement>, data: any)=>{
    setSelectedReport(data.value as string);
    setSelectedDeptForDateWise('');
  }

  const handleViewReport = async ()=>{
    setLoading(true);
    if (selectedReport === 'Title-Wise'){
      try {
        const response = await agent.NFAIRestoTimeSheet.getTimeSheetByTitle(selectedTitle, department, empId);
        setTitleWise(response.data);
      } catch (error) {
        toast.error('Error fetching report data')
      } finally {
        setLoading(false);
      }
    } else if (selectedReport === 'Date-Wise'){
      try {
        let response;
        if (empId === 'Mohamed Ehagaya' || user?.displayName === "E1709" || user?.displayName === "R3077") {
          response = await agent.NFAIRestoTimeSheet.getTimeSheetByDateForAdmin(startDate, endDate, selectedDeptForDateWise);
        } else {
          response = await agent.NFAIRestoTimeSheet.getTimeSheetByDate(startDate, endDate, department, empId);
        }
        setDateWise(response.data);
      } catch (error) {
        toast.error('Error fetching report data')
      } finally{
        setLoading(false);
      }
    } else if (selectedReport === 'Team-Wise'){
      try {
        const response = await agent.NFAIRestoTimeSheet.getTimeSheetByTeam(selectedDept);
        setTeamWise(response.data);
      } catch (error) {
        toast.error('Error fetching report data')
      } finally{
        setLoading(false);
      }
    } else if (selectedReport === 'Employee-Wise'){
      try {
        const response = await agent.NFAIRestoTimeSheet.getTimeSheetByEmployee(selectedEmp);
        setEmployeeWise(response.data)
      } catch (error) {
        toast.error('Error fetching report data')
      } finally {
        setLoading(false)
      }
    }
  }
  
  const handleDownloadReport = () =>{
    let csvContent = "data:text/csv;charset=utf-8,";

    if (selectedReport === 'Title-Wise'){
      csvContent += "Date,Employee ID,Employee Name,Title,UCC ID,Batch,Total Reel,Total Scanned Frames,Total Duration,Rejection Minutes,No of Corrections,Types of Correction,Type of Film,Scope of Work,Start Reel,End Reel,Comp Reel,Start Time,End Time,Total Hours,Status,Remarks\n";
      titleWise.forEach(data => {
          const row = `${data.date},${data.emp_ID},${data.emp_Name},${data.title},${data.ucC_ID},${data.batch},${data.total_Reel},${data.total_Scanned_Frames},${data.total_Duration},${data.rejection_Minutes},${data.no_of_Corrections},${data.types_of_Correction},${data.type_of_Film_BW_Color},${data.scope_of_work},${data.start_Reel},${data.end_Reel},${data.comp_Reel},${data.start_time},${data.end_time},${data.total_Hours},${data.status},${data.remarks}`;
          csvContent += row + "\n";
      });
    } else if (selectedReport === 'Date-Wise'){
      csvContent += "Date,Employee ID,Employee Name,Title,UCC ID,Batch,Total Reel,Total Scanned Frames,Total Duration,Rejection Minutes,No of Corrections,Types of Correction,Type of Film,Scope of Work,Start Reel,End Reel,Comp Reel,Start Time,End Time,Total Hours,Status,Remarks\n";
        dateWise.forEach(data => {
            const row = `${data.date},${data.emp_ID},${data.emp_Name},${data.title},${data.ucC_ID},${data.batch},${data.total_Reel},${data.total_Scanned_Frames},${data.total_Duration},${data.rejection_Minutes},${data.no_of_Corrections},${data.types_of_Correction},${data.type_of_Film_BW_Color},${data.scope_of_work},${data.start_Reel},${data.end_Reel},${data.comp_Reel},${data.start_time},${data.end_time},${data.total_Hours},${data.status},${data.remarks}`;
            csvContent += row + "\n";
        });
    } else if (selectedReport === 'Team-Wise'){
      csvContent += "Date,Employee ID,Employee Name,Title,UCC ID,Batch,Total Reel,Total Scanned Frames,Total Duration,Rejection Minutes,No of Corrections,Types of Correction,Type of Film,Scope of Work,Start Reel,End Reel,Comp Reel,Start Time,End Time,Total Hours,Status,Remarks\n";
        teamWise.forEach(data => {
            const row = `${data.date},${data.emp_ID},${data.emp_Name},${data.title},${data.ucC_ID},${data.batch},${data.total_Reel},${data.total_Scanned_Frames},${data.total_Duration},${data.rejection_Minutes},${data.no_of_Corrections},${data.types_of_Correction},${data.type_of_Film_BW_Color},${data.scope_of_work},${data.start_Reel},${data.end_Reel},${data.comp_Reel},${data.start_time},${data.end_time},${data.total_Hours},${data.status},${data.remarks}`;
            csvContent += row + "\n";
        });
    } else if (selectedReport === 'Employee-Wise'){
      csvContent += "Date,Employee ID,Employee Name,Title,UCC ID,Batch,Total Reel,Total Scanned Frames,Total Duration,Rejection Minutes,No of Corrections,Types of Correction,Type of Film,Scope of Work,Start Reel,End Reel,Comp Reel,Start Time,End Time,Total Hours,Status,Remarks\n";
        employeeWise.forEach(data => {
            const row = `${data.date},${data.emp_ID},${data.emp_Name},${data.title},${data.ucC_ID},${data.batch},${data.total_Reel},${data.total_Scanned_Frames},${data.total_Duration},${data.rejection_Minutes},${data.no_of_Corrections},${data.types_of_Correction},${data.type_of_Film_BW_Color},${data.scope_of_work},${data.start_Reel},${data.end_Reel},${data.comp_Reel},${data.start_time},${data.end_time},${data.total_Hours},${data.status},${data.remarks}`;
            csvContent += row + "\n";
        });
    }

    const date = new Date();
    const formattedDate = date.toISOString().slice(0, 10); 
    const selectedProjectName = projectList.find((val) => val.id === selectedTitle)?.name;
    const filename = () => {
        if (selectedReport === 'Title-Wise') {
            return `${selectedProjectName}_${formattedDate}.csv`;
        } else if (selectedReport === 'Date-Wise') {
            return `from-${startDate}_to-${endDate}${empId === 'Mohamed Ehagaya' || user?.displayName === "E1709" || user?.displayName === "R3077" ? `_dept-${selectedDeptForDateWise}` : ''}.csv`;
        } else if (selectedReport === 'Team-Wise') {
            return `${selectedDept}_${formattedDate}.csv`;
        } else if (selectedReport === 'Employee-Wise') {
            return `${selectedEmp}_${formattedDate}.csv`;
        }
        return '';
    };
    
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); 
  };

  return (
    <div style={{padding: '20px', transform: 'scale(0.90)', transformOrigin: 'top left'}}>
    <div style={{display:"flex", alignItems: 'center', marginBottom:'20px'}}>
      <div style={{marginRight: "10px"}}>
          <label style={{fontWeight:"bold"}}>Report Type</label>
          <Dropdown
            clearable
            placeholder='Select an option'
            fluid
            selection
            options={empId === 'Mohamed Ehagaya' || user?.displayName === "E1709" || user?.displayName === "R3077" ? adminReportOptions : reportOptions}
            onChange={handleChangeReport}
            style={{width:"250px"}}
          />
     </div>
     {selectedReport === 'Title-Wise' ? (
      <>   
          <div style={{ marginRight: "10px" }}>
            <label style={{ fontWeight: "bold" }}>Title Code</label>
            <Dropdown
              clearable
              placeholder='Select an option'
              fluid
              search
              selection
              options={projectList.map((project) => ({
                key: project.id,
                value: project.id,
                text: project.name,
              }))}
              loading={titleLoader}
              value={selectedTitle}
              onChange={handleChangeTitle}
              style={{ width: "250px" }} />
          </div>
          <div style={{ marginRight: "10px", alignSelf: 'end' }}>
              <Button primary onClick={handleViewReport} disabled={!selectedTitle}>View Report</Button>
              <Button style={{ width: '50px' }} onClick={handleDownloadReport} disabled={teamWise.length === 0}><Icon name='download' /></Button>
          </div>
      </> 
     ): null}
     {selectedReport === 'Date-Wise' ? (
        <>
            <div style={{ marginRight: "10px" }}>
              <label style={{ fontWeight: "bold" }}>From</label>
              <DatePicker
                selected={startDate ? moment(startDate, 'MM-DD-YYYY').toDate() : null}
                className="date-picker-style-m0"
                maxDate={moment().toDate()}
                onChange={(date: Date) => setDate(date, 'start')}
              />
            </div>
            <div style={{ marginRight: "10px" }}>
              <label style={{ fontWeight: "bold" }}>To</label>
              <DatePicker
                selected={endDate ? moment(endDate, 'MM-DD-YYYY').toDate() : null}
                className="date-picker-style-m0"
                maxDate={moment().toDate()}
                onChange={(date: Date) => setDate(date, 'end')}
              />
            </div>
            {/* //eslint-disable-next-line */}
            {empId === 'Mohamed Ehagaya' ||
            //eslint-disable-next-line
              user?.displayName === "E1709" || 
             //eslint-disable-next-line
             user?.displayName === "R3077" && (
              <div style={{ marginRight: "10px" }}>
                <label style={{ fontWeight: "bold" }}>Department</label>
                <Dropdown
                  clearable
                  placeholder='Select department'
                  fluid
                  selection
                  options={deptOptions}
                  value={selectedDeptForDateWise}
                  onChange={handleChangeDeptForDateWise}
                  style={{ width: "250px" }}
                />
              </div>
            )}
            <div style={{ marginRight: "10px", alignSelf: 'end' }}>
                  <Button primary onClick={handleViewReport}>View Report</Button>
                  <Button style={{ width: '50px' }} onClick={handleDownloadReport}><Icon name='download' /></Button>
            </div>
        </>
     ): null}
     {selectedReport === 'Team-Wise' ? (
      <>
          <div style={{ marginRight: "10px" }}>
            <label style={{ fontWeight: "bold" }}>Team</label>
            <Dropdown
              clearable
              placeholder='Select an option'
              fluid
              search
              selection
              options={deptOptions}
              value={selectedDept}
              onChange={handleChangeDept}
              style={{ width: "250px" }} />
          </div>
          <div style={{ marginRight: "10px", alignSelf: 'end' }}>
              <Button primary onClick={handleViewReport}>View Report</Button>
              <Button style={{ width: '50px' }} onClick={handleDownloadReport}><Icon name='download' /></Button>
          </div>
      </>
     ): null}
     {selectedReport === 'Employee-Wise' ? (
      <>
          <div style={{ marginRight: "10px" }}>
            <label style={{ fontWeight: "bold" }}>Employee</label>
            <Dropdown
              clearable
              placeholder='Select an option'
              fluid
              search
              selection
              options={empOptions}
              value={selectedEmp}
              onChange={handleChangeEmp}
              style={{ width: "250px" }} />
          </div>
          <div style={{ marginRight: "10px", alignSelf: 'end' }}>
              <Button primary onClick={handleViewReport}>View Report</Button>
              <Button style={{ width: '50px' }} onClick={handleDownloadReport}><Icon name='download' /></Button>
          </div>
      </>
     ): null}
    </div>
    {loading ? (
      <Loader active inline='centered' />
    ): (
      <div>
        {selectedReport === 'Title-Wise' && selectedTitle && (
           <div>
                  <Table celled striped>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>Employee ID</Table.HeaderCell>
                        <Table.HeaderCell>Employee Name</Table.HeaderCell>
                        <Table.HeaderCell>Title</Table.HeaderCell>
                        <Table.HeaderCell>UCC ID</Table.HeaderCell>
                        <Table.HeaderCell>Batch</Table.HeaderCell>
                        <Table.HeaderCell>Total Reel</Table.HeaderCell>
                        <Table.HeaderCell>Total Scanned Frames</Table.HeaderCell>
                        <Table.HeaderCell>Total Duration</Table.HeaderCell>
                        <Table.HeaderCell>Rejection Minutes</Table.HeaderCell>
                        <Table.HeaderCell>No of Corrections</Table.HeaderCell>
                        <Table.HeaderCell>Types of Correction</Table.HeaderCell>
                        <Table.HeaderCell>Type of Film</Table.HeaderCell>
                        <Table.HeaderCell>Scope of Work</Table.HeaderCell>
                        <Table.HeaderCell>Start Reel</Table.HeaderCell>
                        <Table.HeaderCell>End Reel</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel Frames</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel Duration</Table.HeaderCell>
                        <Table.HeaderCell>Start Time</Table.HeaderCell>
                        <Table.HeaderCell>End Time</Table.HeaderCell>
                        <Table.HeaderCell>Total Hours</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell>Remarks</Table.HeaderCell>
                    </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {titleWise.length === 0 ? (
                          <Table.Row>
                          <Table.Cell colSpan={22} textAlign="center">No data available</Table.Cell>
                          </Table.Row>
                          ) : (
                          titleWise.length > 0 && titleWise.map((report, index) => (
                          <Table.Row key={index}>
                                <Table.Cell>{report.date}</Table.Cell>
                                <Table.Cell>{report.emp_ID}</Table.Cell>
                                <Table.Cell>{report.emp_Name}</Table.Cell>
                                <Table.Cell>{report.title}</Table.Cell>
                                <Table.Cell>{report.ucC_ID}</Table.Cell>
                                <Table.Cell>{report.batch}</Table.Cell>
                                <Table.Cell>{report.total_Reel}</Table.Cell>
                                <Table.Cell>{report.total_Scanned_Frames}</Table.Cell>
                                <Table.Cell>{report.total_Duration}</Table.Cell>
                                <Table.Cell>{report.rejection_Minutes}</Table.Cell>
                                <Table.Cell>{report.no_of_Corrections}</Table.Cell>
                                <Table.Cell>{report.types_of_Correction}</Table.Cell>                               
                                <Table.Cell>{report.type_of_Film_BW_Color}</Table.Cell>
                                <Table.Cell>{report.scope_of_work}</Table.Cell>
                                <Table.Cell>{report.start_Reel}</Table.Cell>
                                <Table.Cell>{report.end_Reel}</Table.Cell>
                                <Table.Cell>{report.comp_Reel}</Table.Cell>
                                <Table.Cell>{report.comp_Reel_Frames}</Table.Cell>
                                <Table.Cell>{report.comp_Reel_Frames_Duration}</Table.Cell>
                                <Table.Cell>{report.start_time}</Table.Cell>
                                <Table.Cell>{report.end_time}</Table.Cell>
                                <Table.Cell>{report.total_Hours}</Table.Cell>
                                <Table.Cell>{report.status}</Table.Cell>
                                <Table.Cell>{report.remarks}</Table.Cell>
                          </Table.Row>
                          ))
                        )}
                        {titleWise.length > 0 && (
                          <Table.Row>
                            <Table.Cell style={{ textAlign: 'right' }} colSpan={14}><b>Comp Reel Total: {calculateTotals(titleWise).totalCompReel}</b></Table.Cell>
                            <Table.Cell style={{ marginLeft: '30px' }} colSpan={11}><b>Total Hours: {calculateTotals(titleWise).totalHours}</b></Table.Cell>
                          </Table.Row>
                        )}
                  </Table.Body>
                </Table>
           </div>
        )}
        {selectedReport === 'Date-Wise' && (
           <div>
                  <Table celled striped>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>Employee ID</Table.HeaderCell>
                        <Table.HeaderCell>Employee Name</Table.HeaderCell>
                        <Table.HeaderCell>Title</Table.HeaderCell>
                        <Table.HeaderCell>UCC ID</Table.HeaderCell>
                        <Table.HeaderCell>Batch</Table.HeaderCell>
                        <Table.HeaderCell>Total Reel</Table.HeaderCell>
                        <Table.HeaderCell>Total Scanned Frames</Table.HeaderCell>
                        <Table.HeaderCell>Total Duration</Table.HeaderCell>
                        <Table.HeaderCell>Rejection Minutes</Table.HeaderCell>
                        <Table.HeaderCell>No of Corrections</Table.HeaderCell>
                        <Table.HeaderCell>Types of Correction</Table.HeaderCell>
                        <Table.HeaderCell>Type of Film</Table.HeaderCell>
                        <Table.HeaderCell>Scope of Work</Table.HeaderCell>
                        <Table.HeaderCell>Start Reel</Table.HeaderCell>
                        <Table.HeaderCell>End Reel</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel Frames</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel Duration</Table.HeaderCell>
                        <Table.HeaderCell>Start Time</Table.HeaderCell>
                        <Table.HeaderCell>End Time</Table.HeaderCell>
                        <Table.HeaderCell>Total Hours</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell>Remarks</Table.HeaderCell>
                    </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {dateWise.length === 0 ? (
                          <Table.Row>
                          <Table.Cell colSpan={22} textAlign="center">No data available</Table.Cell>
                          </Table.Row>
                          ) : (
                          dateWise.length > 0 && dateWise.map((report, index) => (
                          <Table.Row key={index}>
                                <Table.Cell>{report.date}</Table.Cell>
                                <Table.Cell>{report.emp_ID}</Table.Cell>
                                <Table.Cell>{report.emp_Name}</Table.Cell>
                                <Table.Cell>{report.title}</Table.Cell>
                                <Table.Cell>{report.ucC_ID}</Table.Cell>
                                <Table.Cell>{report.batch}</Table.Cell>
                                <Table.Cell>{report.total_Reel}</Table.Cell>
                                <Table.Cell>{report.total_Scanned_Frames}</Table.Cell>
                                <Table.Cell>{report.total_Duration}</Table.Cell>
                                <Table.Cell>{report.rejection_Minutes}</Table.Cell>
                                <Table.Cell>{report.no_of_Corrections}</Table.Cell>
                                <Table.Cell>{report.types_of_Correction}</Table.Cell>                               
                                <Table.Cell>{report.type_of_Film_BW_Color}</Table.Cell>
                                <Table.Cell>{report.scope_of_work}</Table.Cell>
                                <Table.Cell>{report.start_Reel}</Table.Cell>
                                <Table.Cell>{report.end_Reel}</Table.Cell>
                                <Table.Cell>{report.comp_Reel}</Table.Cell>
                                <Table.Cell>{report.comp_Reel_Frames}</Table.Cell>
                                <Table.Cell>{report.comp_Reel_Frames_Duration}</Table.Cell>
                                <Table.Cell>{report.start_time}</Table.Cell>
                                <Table.Cell>{report.end_time}</Table.Cell>
                                <Table.Cell>{report.total_Hours}</Table.Cell>
                                <Table.Cell>{report.status}</Table.Cell>
                                <Table.Cell>{report.remarks}</Table.Cell>
                          </Table.Row>
                          ))
                        )}
                        {dateWise.length > 0 && (
                          <Table.Row>
                            <Table.Cell style={{ textAlign: 'right' }} colSpan={14}><b>Comp Reel Total: {calculateTotals(dateWise).totalCompReel}</b></Table.Cell>
                            <Table.Cell style={{ marginLeft: '30px' }} colSpan={10}><b>Total Hours: {calculateTotals(dateWise).totalHours}</b></Table.Cell>
                          </Table.Row>
                        )}
                  </Table.Body>
                </Table>
           </div>
        )}
        {selectedReport === 'Team-Wise' && selectedDept && (
           <div>
                  <Table celled striped>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>Employee ID</Table.HeaderCell>
                        <Table.HeaderCell>Employee Name</Table.HeaderCell>
                        <Table.HeaderCell>Title</Table.HeaderCell>
                        <Table.HeaderCell>UCC ID</Table.HeaderCell>
                        <Table.HeaderCell>Batch</Table.HeaderCell>
                        <Table.HeaderCell>Total Reel</Table.HeaderCell>
                        <Table.HeaderCell>Total Scanned Frames</Table.HeaderCell>
                        <Table.HeaderCell>Total Duration</Table.HeaderCell>
                        <Table.HeaderCell>Rejection Minutes</Table.HeaderCell>
                        <Table.HeaderCell>No of Corrections</Table.HeaderCell>
                        <Table.HeaderCell>Types of Correction</Table.HeaderCell>
                        <Table.HeaderCell>Type of Film</Table.HeaderCell>
                        <Table.HeaderCell>Scope of Work</Table.HeaderCell>
                        <Table.HeaderCell>Start Reel</Table.HeaderCell>
                        <Table.HeaderCell>End Reel</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel Frames</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel Duration</Table.HeaderCell>
                        <Table.HeaderCell>Start Time</Table.HeaderCell>
                        <Table.HeaderCell>End Time</Table.HeaderCell>
                        <Table.HeaderCell>Total Hours</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell>Remarks</Table.HeaderCell>
                    </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {teamWise.length === 0 ? (
                          <Table.Row>
                          <Table.Cell colSpan={22} textAlign="center">No data available</Table.Cell>
                          </Table.Row>
                          ) : (
                          teamWise.length > 0 && teamWise.map((report, index) => (
                          <Table.Row key={index}>
                                <Table.Cell>{report.date}</Table.Cell>
                                <Table.Cell>{report.emp_ID}</Table.Cell>
                                <Table.Cell>{report.emp_Name}</Table.Cell>
                                <Table.Cell>{report.title}</Table.Cell>
                                <Table.Cell>{report.ucC_ID}</Table.Cell>
                                <Table.Cell>{report.batch}</Table.Cell>
                                <Table.Cell>{report.total_Reel}</Table.Cell>
                                <Table.Cell>{report.total_Scanned_Frames}</Table.Cell>
                                <Table.Cell>{report.total_Duration}</Table.Cell>
                                <Table.Cell>{report.rejection_Minutes}</Table.Cell>
                                <Table.Cell>{report.no_of_Corrections}</Table.Cell>
                                <Table.Cell>{report.types_of_Correction}</Table.Cell>                               
                                <Table.Cell>{report.type_of_Film_BW_Color}</Table.Cell>
                                <Table.Cell>{report.scope_of_work}</Table.Cell>
                                <Table.Cell>{report.start_Reel}</Table.Cell>
                                <Table.Cell>{report.end_Reel}</Table.Cell>
                                <Table.Cell>{report.comp_Reel}</Table.Cell>
                                <Table.Cell>{report.comp_Reel_Frames}</Table.Cell>
                                <Table.Cell>{report.comp_Reel_Frames_Duration}</Table.Cell>
                                <Table.Cell>{report.start_time}</Table.Cell>
                                <Table.Cell>{report.end_time}</Table.Cell>
                                <Table.Cell>{report.total_Hours}</Table.Cell>
                                <Table.Cell>{report.status}</Table.Cell>
                                <Table.Cell>{report.remarks}</Table.Cell>
                          </Table.Row>
                          ))
                        )}
                        {teamWise.length > 0 && (
                          <Table.Row>
                            <Table.Cell style={{ textAlign: 'right' }} colSpan={14}><b>Comp Reel Total: {calculateTotals(teamWise).totalCompReel}</b></Table.Cell>
                            <Table.Cell style={{ marginLeft: '30px' }} colSpan={11}><b>Total Hours: {calculateTotals(teamWise).totalHours}</b></Table.Cell>
                          </Table.Row>
                        )}
                  </Table.Body>
                </Table>
           </div>
        )}        
        {selectedReport === 'Employee-Wise' && selectedEmp && (
           <div>
                  <Table celled striped>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>Employee ID</Table.HeaderCell>
                        <Table.HeaderCell>Employee Name</Table.HeaderCell>
                        <Table.HeaderCell>Title</Table.HeaderCell>
                        <Table.HeaderCell>UCC ID</Table.HeaderCell>
                        <Table.HeaderCell>Batch</Table.HeaderCell>
                        <Table.HeaderCell>Total Reel</Table.HeaderCell>
                        <Table.HeaderCell>Total Scanned Frames</Table.HeaderCell>
                        <Table.HeaderCell>Total Duration</Table.HeaderCell>
                        <Table.HeaderCell>Rejection Minutes</Table.HeaderCell>
                        <Table.HeaderCell>No of Corrections</Table.HeaderCell>
                        <Table.HeaderCell>Types of Correction</Table.HeaderCell>
                        <Table.HeaderCell>Type of Film</Table.HeaderCell>
                        <Table.HeaderCell>Scope of Work</Table.HeaderCell>
                        <Table.HeaderCell>Start Reel</Table.HeaderCell>
                        <Table.HeaderCell>End Reel</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel Frames</Table.HeaderCell>
                        <Table.HeaderCell>Comp Reel Duration</Table.HeaderCell>
                        <Table.HeaderCell>Start Time</Table.HeaderCell>
                        <Table.HeaderCell>End Time</Table.HeaderCell>
                        <Table.HeaderCell>Total Hours</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell>Remarks</Table.HeaderCell>
                    </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {employeeWise.length === 0 ? (
                          <Table.Row>
                          <Table.Cell colSpan={22} textAlign="center">No data available</Table.Cell>
                          </Table.Row>
                          ) : (
                          employeeWise.length > 0 && employeeWise.map((report, index) => (
                          <Table.Row key={index}>
                                <Table.Cell>{report.date}</Table.Cell>
                                <Table.Cell>{report.emp_ID}</Table.Cell>
                                <Table.Cell>{report.emp_Name}</Table.Cell>
                                <Table.Cell>{report.title}</Table.Cell>
                                <Table.Cell>{report.ucC_ID}</Table.Cell>
                                <Table.Cell>{report.batch}</Table.Cell>
                                <Table.Cell>{report.total_Reel}</Table.Cell>
                                <Table.Cell>{report.total_Scanned_Frames}</Table.Cell>
                                <Table.Cell>{report.total_Duration}</Table.Cell>
                                <Table.Cell>{report.rejection_Minutes}</Table.Cell>
                                <Table.Cell>{report.no_of_Corrections}</Table.Cell>
                                <Table.Cell>{report.types_of_Correction}</Table.Cell>                               
                                <Table.Cell>{report.type_of_Film_BW_Color}</Table.Cell>
                                <Table.Cell>{report.scope_of_work}</Table.Cell>
                                <Table.Cell>{report.start_Reel}</Table.Cell>
                                <Table.Cell>{report.end_Reel}</Table.Cell>
                                <Table.Cell>{report.comp_Reel}</Table.Cell>
                                <Table.Cell>{report.comp_Reel_Frames}</Table.Cell>
                                <Table.Cell>{report.comp_Reel_Frames_Duration}</Table.Cell>
                                <Table.Cell>{report.start_time}</Table.Cell>
                                <Table.Cell>{report.end_time}</Table.Cell>
                                <Table.Cell>{report.total_Hours}</Table.Cell>
                                <Table.Cell>{report.status}</Table.Cell>
                                <Table.Cell>{report.remarks}</Table.Cell>
                          </Table.Row>
                          ))
                        )}
                        {employeeWise.length > 0 && (
                          <Table.Row>
                            <Table.Cell style={{ textAlign: 'right' }} colSpan={14}><b>Comp Reel Total: {calculateTotals(employeeWise).totalCompReel}</b></Table.Cell>
                            <Table.Cell style={{ marginLeft: '30px' }} colSpan={11}><b>Total Hours: {calculateTotals(employeeWise).totalHours}</b></Table.Cell>
                          </Table.Row>
                        )}
                  </Table.Body>
                </Table>
           </div>
        )}
      </div>
    )}
    </div>
  );
};

export default observer(NFAIDAilyReport);
